var map = {
	"./da/main.yml": 56,
	"./da/main2.yml": 67,
	"./de/dio.yml": 196,
	"./de/main.yml": 57,
	"./de/main2.yml": 68,
	"./de/sfs.yml": 197,
	"./en/dio.yml": 198,
	"./en/home.yml": 199,
	"./en/hos.yml": 200,
	"./en/main.yml": 58,
	"./en/main2.yml": 69,
	"./en/sfs.yml": 201,
	"./es/dio.yml": 202,
	"./es/hos.yml": 203,
	"./es/main.yml": 59,
	"./es/main2.yml": 70,
	"./es/sfs.yml": 204,
	"./fr/dio.yml": 205,
	"./fr/home.yml": 206,
	"./fr/hos.yml": 207,
	"./fr/main.yml": 60,
	"./fr/main2.yml": 71,
	"./fr/sfs.yml": 208,
	"./gd/main.yml": 61,
	"./gd/main2.yml": 72,
	"./id/main.yml": 62,
	"./id/main2.yml": 73,
	"./it/dio.yml": 209,
	"./it/hos.yml": 210,
	"./it/main.yml": 63,
	"./it/main2.yml": 74,
	"./it/sfs.yml": 211,
	"./pt_BR/hos.yml": 212,
	"./pt_BR/main.yml": 64,
	"./ru/main.yml": 65,
	"./ru/main2.yml": 75,
	"./si/main2.yml": 76,
	"./si/sfs.yml": 213,
	"./tr/main.yml": 66,
	"./tr/main2.yml": 77
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 195;